import React from 'react';
import PropTypes from 'prop-types';

/**
 * Pagination - A wrapper that renders a standard HTML nav with Bulma class names
 *
 * This component accepts the same props as Bloomer Pagination for easy migration
 */
const Pagination = ({ className, children, style, isAlign = null, isSize = null, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['pagination'];

    if (className) {
      classes.push(className);
    }

    if (isAlign) {
      classes.push(`is-${isAlign}`);
    }

    if (isSize) {
      classes.push(`is-${isSize}`);
    }

    return classes.join(' ');
  };

  // Strip custom props that shouldn't go to DOM
  const { isAlign: _ia, isSize: _is, ...domProps } = props;

  return (
    <nav className={getClassNames()} style={style} {...domProps}>
      {children}
    </nav>
  );
};

Pagination.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Pagination.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default Pagination;
